import React, { useEffect, useRef, useState } from 'react';
import CarritoResumen from './CarritoResumen';
import './Carrito.css';
import { useCarrito } from '../context/CarritoContext';
import ensureAbsoluteImg from '../utils/urls';

// Utilidad local para normalizar series igual que en Ventas
const normalizarSerie = (s) => {
  if (s === undefined || s === null) return '';
  try { return s.toString().toLowerCase().replace(/\s+/g,'').replace(/[-_]/g,''); } catch { return ''; }
};

// Ahora el apartado Carrito muestra el resumen completo y flujo de pago/ticket
export default function Carrito() {
  const { carrito, actualizarCantidad, agregarAlCarrito, setCarrito } = useCarrito();
  const [productos, setProductos] = useState([]); // cache para permitir agregar también desde aquí
  const [scanBuffer, setScanBuffer] = useState('');
  const [lastKeyTime, setLastKeyTime] = useState(0);
  const scanThreshold = 45; // ms
  const inputRef = useRef(null);
  const searchSerieRef = useRef(null);
  const [flash, setFlash] = useState(false);
  const audioCtxRef = useRef(null);
  const containerRef = useRef(null);
  const [variantModal, setVariantModal] = useState({ open: false, options: [], scannedCode: '' });
  const [serieText, setSerieText] = useState('');
  const lastTrigger = useRef(null); // 'manual' | 'scan'
  const [descuentoPct, setDescuentoPct] = useState(0);

  // Aplica el descuento a todos los productos del carrito cuando cambia el porcentaje
  useEffect(() => {
    setCarrito(prev => prev.map(item => {
      const precioOriginal = item.precioOriginal != null ? item.precioOriginal : item.precio;
      if (descuentoPct > 0) {
        const precioDesc = +(precioOriginal * (1 - descuentoPct/100)).toFixed(2);
        return { ...item, precio: precioDesc, precioOriginal, descuentoPorcentaje: descuentoPct };
      } else {
        return { ...item, precio: precioOriginal, descuentoPorcentaje: 0 };
      }
    }));
  }, [descuentoPct, setCarrito]);
  // Datos del cliente y notas del ticket
  const [clienteNombre, setClienteNombre] = useState('');
  const [clienteTelefono, setClienteTelefono] = useState('');
  const [notasTicket, setNotasTicket] = useState('');

  // Función para imprimir ticket (reutilizada por CarritoResumen vía prop onImprimir)
  const imprimirTicket = (payload) => {
    if(!payload) return;
    const { carrito: lineas = [], subtotal = 0, descuento = 0, iva = 0, total = 0, metodoPago, recibido, cambio, folio, clienteNombre: pNombre, clienteTelefono: pTel, notas: pNotas } = payload;
    const win = window.open('', 'PRINT_TICKET', 'height=650,width=400');
    if(!win){ alert('El navegador bloqueó la ventana de impresión. Permite popups.'); return; }
    const fmt = (n)=> new Intl.NumberFormat('es-MX',{style:'currency',currency:'MXN'}).format(Number(n)||0);
    const totalCant = lineas.reduce((a,l)=> a + (l.cantidad||0),0);
    const fecha = new Date().toLocaleString('es-MX');
    const metodoLabel = (
      metodoPago === 'efectivo' ? 'Efectivo' :
      metodoPago === 'tarjeta' ? 'Tarjeta' :
      metodoPago === 'transferencia' ? 'Transferencia' :
      metodoPago || 'Otro'
    );
    const logoSrc = '/img/logo.png'; // usa el logo público si existe

    win.document.write(`<!DOCTYPE html><html><head><title>Ticket ${folio? '#'+folio:''}</title>
      <meta charset="utf-8" />
      <style>
        *{ box-sizing:border-box; }
        body{ margin:0; padding:12px; color:#111; }
        .ticket{ width:280px; font-family: ui-sans-serif, -apple-system, Segoe UI, Roboto, Arial, "Noto Sans", "Segoe UI Symbol"; }
        .header{ display:flex; align-items:center; gap:8px; }
        .logo{ width:42px; height:42px; object-fit:contain; }
        .brand{ display:flex; flex-direction:column; }
        .brand .name{ font-weight:700; letter-spacing:0.3px; }
        .brand .sub{ font-size:12px; color:#444; }
        .muted{ color:#555; font-size:12px; }
        .hr{ border-top:1px dashed #777; margin:8px 0; }
        .info{ font-size:12px; display:flex; justify-content:space-between; gap:10px; }
        .title{ text-align:center; font-weight:600; margin-top:4px; }
        table{ width:100%; border-collapse:collapse; table-layout:fixed; }
        thead th{ border-bottom:1px solid #000; padding:3px 2px; font-size:12px; text-align:left; }
        thead th.qty{ width:28px; text-align:right; }
  thead th.pu{ width:86px; text-align:right; }
        thead th.imp{ width:78px; text-align:right; }
        tbody td{ padding:3px 2px; font-size:12px; vertical-align:top; }
        td.qty{ text-align:right; white-space:nowrap; font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-feature-settings:'tnum' 1,'lnum' 1; }
        td.pu, td.imp{ text-align:right; white-space:nowrap; font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-feature-settings:'tnum' 1,'lnum' 1; }
  td.pu .old{ text-decoration: line-through; color:#666; }
  td.pu .sep{ margin: 0 6px; color:#555; }
        .desc{ word-break:break-word; hyphens:auto; }
        .desc .subline{ color:#666; font-size:11px; }
        .totales{ margin-top:6px; font-size:12px; }
        .tot-row{ display:flex; justify-content:space-between; padding:2px 0; gap:8px; }
        .tot-row.total{ border-top:1px solid #000; margin-top:4px; padding-top:6px; font-weight:700; font-size:13px; }
        .tot-row .val{ min-width:86px; text-align:right; font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-feature-settings:'tnum' 1,'lnum' 1; }
        .foot{ text-align:center; margin-top:10px; font-size:11px; color:#333; }
        @media print { body{ padding:0; } }
      </style>
    </head><body>
      <div class="ticket">
        <div class="header">
          <img class="logo" src="${logoSrc}" alt="logo" onerror="this.style.display='none'" />
          <div class="brand">
            <div class="name">SAFETYPOINT</div>
            <div class="sub">Ticket de venta</div>
          </div>
        </div>
        <div class="info">
          <div>${folio? `Folio: <strong>${folio}</strong>`:'&nbsp;'}</div>
          <div>${fecha}</div>
        </div>
        ${(pNombre||pTel)? `<div class="muted" style="margin-top:6px; line-height:1.3">
          ${pNombre? `<div><strong>Cliente:</strong> ${pNombre}</div>`:''}
          ${pTel? `<div><strong>Tel:</strong> ${pTel}</div>`:''}
        </div>`:''}
        <div class="hr"></div>
        <table>
          <colgroup>
            <col style="width:30px" />
            <col />
            <col style="width:70px" />
            <col style="width:78px" />
          </colgroup>
          <thead>
            <tr>
              <th class="qty">Cant</th>
              <th>Descripción</th>
              <th class="pu">P.U.</th>
              <th class="imp">Importe</th>
            </tr>
          </thead>
          <tbody>
          ${lineas.map(l=>{
            const base = l.precioOriginal != null ? l.precioOriginal : l.precio;
            const descU = l.precioOriginal != null ? (base - l.precio) : 0;
            const unit = base - descU;
            const imp = (l.precio * l.cantidad);
            const nombreBase = (l.concepto||l.nombre||'Producto');
            const nombre = (l.talla && !nombreBase.includes('('+l.talla+')') ? `${nombreBase} (${l.talla})` : nombreBase);
            const descLine = (descU>0) ? `<div class=\"subline\">Desc. u: ${unit < base ? (base - unit).toFixed(2) : '0.00'}</div>` : '';
            return `
              <tr>
                <td class=\"qty\">${l.cantidad}</td>
                <td class=\"desc\"><div>${nombre}</div>${descLine}</td>
                <td class=\"pu\">${descU>0 ? `<span class=\\"old\\">${base.toFixed(2)}</span><span class=\\"sep\\">→</span><strong>${unit.toFixed(2)}</strong>` : unit.toFixed(2)}</td>
                <td class=\"imp\">${imp.toFixed(2)}</td>
              </tr>`;
          }).join('')}
          </tbody>
        </table>
        <div class="hr"></div>
        <div class="totales">
          <div class="tot-row"><span>Artículos</span><span class="val">${totalCant}</span></div>
          <div class="tot-row"><span>Sub Bruto</span><span class="val">${fmt(subtotal)}</span></div>
          <div class="tot-row"><span>Descuento</span><span class="val">-${fmt(descuento)}</span></div>
          <div class="tot-row"><span>Sub Neto</span><span class="val">${fmt(subtotal - descuento)}</span></div>
          <div class="tot-row"><span>IVA</span><span class="val">${fmt(iva)}</span></div>
          <div class="tot-row total"><span>Total</span><span class="val">${fmt(total)}</span></div>
          ${metodoPago==='efectivo' && recibido!=null ? `<div class="tot-row"><span>Recibido</span><span class=\"val\">${fmt(recibido)}</span></div>`:''}
          ${metodoPago==='efectivo' && cambio!=null ? `<div class="tot-row"><span>Cambio</span><span class=\"val\">${fmt(cambio)}</span></div>`:''}
          <div class="tot-row"><span>Método</span><span class="val">${metodoLabel}</span></div>
        </div>
        ${pNotas? `<div class="hr"></div><div class="muted" style="white-space:pre-wrap">${(pNotas||'').replace(/[<>]/g,'')}</div>`:''}
        <div class="foot">Conserve este ticket. ¡Gracias por su compra!</div>
      </div>

      <script>
        (function(){
          try{
            var imgs = Array.prototype.slice.call(document.images||[]);
            var done = false, loaded = 0;
            function finish(){ if(done) return; done = true; setTimeout(function(){ try{ window.focus(); window.print(); setTimeout(function(){ window.close(); }, 500); }catch(e){} }, 150); }
            if(imgs.length === 0){ finish(); return; }
            imgs.forEach(function(img){
              if(img.complete){ loaded++; if(loaded===imgs.length) finish(); return; }
              img.addEventListener('load', function(){ loaded++; if(loaded===imgs.length) finish(); });
              img.addEventListener('error', function(){ loaded++; if(loaded===imgs.length) finish(); });
            });
            setTimeout(finish, 1800);
          }catch(e){ window.print(); setTimeout(function(){ window.close(); }, 500); }
        })();
      </script>
    </body></html>`);
    win.document.close();
    win.focus();
  };

  // Cargar y persistir datos del cliente/notas en localStorage
  useEffect(()=>{
    try{
      const ls = window.localStorage;
      setClienteNombre(ls.getItem('carrito.clienteNombre') || '');
      setClienteTelefono(ls.getItem('carrito.clienteTelefono') || '');
      setNotasTicket(ls.getItem('carrito.notasTicket') || '');
    }catch{}
  },[]);
  useEffect(()=>{ try{ window.localStorage.setItem('carrito.clienteNombre', clienteNombre||''); }catch{} }, [clienteNombre]);
  useEffect(()=>{ try{ window.localStorage.setItem('carrito.clienteTelefono', clienteTelefono||''); }catch{} }, [clienteTelefono]);
  useEffect(()=>{ try{ window.localStorage.setItem('carrito.notasTicket', notasTicket||''); }catch{} }, [notasTicket]);

  const initAudio = () => {
    if (!audioCtxRef.current) {
      try { audioCtxRef.current = new (window.AudioContext || window.webkitAudioContext)(); } catch { audioCtxRef.current = null; }
    }
  };
  const playBeep = (f=880,d=120,t='sine',v=0.3) => { const ctx = audioCtxRef.current; if(!ctx) return; const o=ctx.createOscillator(); const g=ctx.createGain(); o.type=t; o.frequency.value=f; g.gain.value=v; o.connect(g).connect(ctx.destination); o.start(); o.stop(ctx.currentTime + d/1000); };
  const beepSuccess = () => { playBeep(1040,90,'square',0.25); setTimeout(()=>playBeep(1560,90,'square',0.20),95); };
  const beepError = () => playBeep(340,170,'sawtooth',0.28);

  // Cargar productos para permitir escaneo directo desde Carrito
  useEffect(()=>{
    fetch('/api/productos')
      .then(r=> r.ok? r.json(): [])
      .then(data => {
        const norm = Array.isArray(data)? data.map(p => ({ ...p, id: p.id_producto, imagen: ensureAbsoluteImg(p.imagenes && p.imagenes.length>0 ? p.imagenes[0].imagen_url : p.imagen) })) : [];
        setProductos(norm);
      })
      .catch(()=>{});
  },[]);

  useEffect(()=>{ if(inputRef.current) inputRef.current.focus(); },[]);

  useEffect(()=>{
    const handler = (e) => {
      if (document.activeElement && document.activeElement.tagName === 'INPUT' && document.activeElement !== inputRef.current) return;
      const now = Date.now();
      if (e.key === 'Enter') {
        const code = scanBuffer.trim();
        if(code.length>0){
          lastTrigger.current = 'scan';
          processSerie(code);
          setScanBuffer('');
          setFlash(true); setTimeout(()=>setFlash(false),250);
          setTimeout(()=> inputRef.current && (inputRef.current.value=''), 80);
        }
        return;
      }
      if(e.key.length===1){
        if(now - lastKeyTime > scanThreshold){ setScanBuffer(e.key); } else { setScanBuffer(prev=> prev + e.key); }
        setLastKeyTime(now);
      }
    };
    window.addEventListener('keydown', handler);
    return ()=> window.removeEventListener('keydown', handler);
  },[scanBuffer,lastKeyTime,productos,carrito]);

  // Procesar una serie (desde escáner o entrada manual)
  const processSerie = (rawCode) => {
    const code = (rawCode||'').trim();
    if(!code) return;
    const norm = normalizarSerie(code);
    const matches = productos.filter(p => normalizarSerie(p.codigo) === norm);
    if(matches.length === 1){
      const prod = matches[0];
      if(descuentoPct>0){
        const precioOriginal = Number(prod.precio)||0;
        const precioDesc = +(precioOriginal * (1 - descuentoPct/100)).toFixed(2);
        agregarAlCarrito({ ...prod, id: prod.id, lineId:`${prod.id}_${descuentoPct}_${Date.now()}` , precio: precioDesc, precioOriginal, descuentoPorcentaje: descuentoPct });
      } else {
        const existente = carrito.find(item => normalizarSerie(item.codigo) === norm && item.id === prod.id && !item.descuentoPorcentaje);
        if(existente){
          actualizarCantidad(existente.lineId || existente.id, (existente.cantidad || 0) + 1);
        } else {
          agregarAlCarrito({ ...prod, id: prod.id });
        }
      }
      beepSuccess();
      // limpiar input manual si aplicó
      setSerieText('');
    } else if(matches.length > 1){
      setVariantModal({ open: true, options: matches, scannedCode: code });
      // sonido para indicar selección requerida
      playBeep(600,120,'sine',0.25);
      playBeep(420,160,'sine',0.25);
    } else {
      // fallback backend exacto
      fetch(`/api/productos/serie/${encodeURIComponent(code)}`)
        .then(r=> r.ok? r.json(): null)
        .then(data => {
          if(data && data.id_producto){
            const prodSrv = { ...data, id: data.id_producto };
            if(descuentoPct>0){
              const precioOriginal = Number(prodSrv.precio)||0;
              const precioDesc = +(precioOriginal * (1 - descuentoPct/100)).toFixed(2);
              agregarAlCarrito({ ...prodSrv, lineId:`${prodSrv.id}_${descuentoPct}_${Date.now()}`, precio: precioDesc, precioOriginal, descuentoPorcentaje: descuentoPct });
            } else {
              const existente = carrito.find(item => normalizarSerie(item.codigo) === norm && item.id === prodSrv.id && !item.descuentoPorcentaje);
              if(existente){
                actualizarCantidad(existente.lineId || existente.id, (existente.cantidad||0) + 1);
              } else {
                agregarAlCarrito(prodSrv);
              }
            }
            beepSuccess();
            setSerieText('');
          } else {
            beepError();
          }
        })
        .catch(()=> beepError());
    }
  };

  const seleccionarVariante = (prod) => {
    const norm = normalizarSerie(prod.codigo);
    if(descuentoPct>0){
      const precioOriginal = Number(prod.precio)||0;
      const precioDesc = +(precioOriginal * (1 - descuentoPct/100)).toFixed(2);
      agregarAlCarrito({ ...prod, id: prod.id, lineId:`${prod.id}_${descuentoPct}_${Date.now()}`, precio: precioDesc, precioOriginal, descuentoPorcentaje: descuentoPct });
    } else {
      const existente = carrito.find(item => normalizarSerie(item.codigo) === norm && item.id === prod.id && !item.descuentoPorcentaje);
      if(existente){
        actualizarCantidad(existente.lineId || existente.id, (existente.cantidad||0) + 1);
      } else {
        agregarAlCarrito({ ...prod, id: prod.id });
      }
    }
    setVariantModal({ open:false, options: [], scannedCode: '' });
    // devolver foco al input adecuado según el origen
    setTimeout(()=> {
      if(lastTrigger.current === 'manual'){
        searchSerieRef.current?.focus();
      } else {
        inputRef.current?.focus();
      }
      lastTrigger.current = null;
    }, 50);
    beepSuccess();
  };

  const cerrarVariante = () => {
    setVariantModal({ open:false, options: [], scannedCode: '' });
    setTimeout(()=> inputRef.current?.focus(), 50);
  };

  return (
    <div className="carrito-container">
      <h2>Punto de Venta / Carrito</h2>
      {/* Selector de descuento */}
      <div style={{display:'flex',gap:8,alignItems:'center',flexWrap:'wrap',margin:'4px 0 8px'}}>
        <span style={{fontSize:12,opacity:.7}}>DESCUENTO:</span>
        <div style={{display:'flex',gap:6,flexWrap:'wrap'}}>
          {[0,5,10,15,20,25,30,40,50].map(p => (
            <button key={p} type="button" onClick={()=> setDescuentoPct(p)}
              className={`btn-modern ${p===descuentoPct? 'primary':'outline'}`} style={{fontSize:12}}>
              {p}%
            </button>
          ))}
        </div>
        {descuentoPct>0 && <span style={{fontSize:12,color:'#d35400'}}>Aplicando -{descuentoPct}% a nuevos artículos</span>}
      </div>
      {/* Buscador visible por número de serie */}
      <div style={{display:'flex',gap:8,alignItems:'center',margin:'6px 0 10px'}}>
        <input
          ref={searchSerieRef}
          type="text"
          placeholder="Buscar por número de serie (Enter)"
          value={serieText}
          onChange={(e)=> setSerieText(e.target.value)}
          onKeyDown={(e)=>{ if(e.key==='Enter'){ lastTrigger.current='manual'; processSerie(serieText); } }}
          onFocus={initAudio}
          onClick={initAudio}
          style={{minWidth:260}}
        />
        <button type="button" onClick={()=>{ lastTrigger.current='manual'; processSerie(serieText); }}>
          Agregar
        </button>
      </div>
      <input
        ref={inputRef}
        type="text"
        placeholder="Escanear aquí"
        onFocus={initAudio}
        onClick={initAudio}
        onBlur={() => {
          // Esperar a que el nuevo activeElement se establezca
          setTimeout(()=> {
            const ae = document.activeElement;
            // Si el foco quedó en un input visible (como el buscador por serie) no robar foco
            if (ae && ae !== inputRef.current && ae.tagName === 'INPUT') return;
            // Si el nuevo foco está dentro del contenedor (select de pago, input recibido, etc.) no robar foco
            if (containerRef.current && containerRef.current.contains(ae) && ae !== inputRef.current) return;
            // Si se fue fuera (click fuera de la vista), retomamos foco al escáner oculto
            inputRef.current?.focus();
          }, 40);
        }}
        className={flash? 'scan-flash' : ''}
        style={{position:'absolute',opacity:0,height:0,width:0,pointerEvents:'none'}}
      />
      <div ref={containerRef}>
        {/* Datos del cliente y notas */}
        <div style={{display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(220px, 1fr))', gap:8, margin:'8px 0 10px'}}>
          <div>
            <label style={{fontSize:12, opacity:.75}}>Nombre del cliente (opcional)</label>
            <input type="text" value={clienteNombre} onChange={e=> setClienteNombre(e.target.value)} placeholder="Nombre" />
          </div>
          <div>
            <label style={{fontSize:12, opacity:.75}}>Teléfono (opcional)</label>
            <input type="tel" value={clienteTelefono} onChange={e=> setClienteTelefono(e.target.value)} placeholder="Teléfono" />
          </div>
          <div style={{gridColumn:'1 / -1'}}>
            <label style={{fontSize:12, opacity:.75}}>Notas del ticket</label>
            <textarea rows={2} value={notasTicket} onChange={e=> setNotasTicket(e.target.value)} placeholder="Comentarios o condiciones" />
          </div>
        </div>
        <CarritoResumen
          clienteNombre={clienteNombre}
          clienteTelefono={clienteTelefono}
          notas={notasTicket}
          onImprimir={(p)=> imprimirTicket({
          ...p,
          clienteNombre,
          clienteTelefono,
          notas: notasTicket
        })}
        />
      </div>
      {variantModal.open && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.55)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9999}}>
          <div style={{background:'#fff',padding:'18px 22px',borderRadius:'8px',width:'360px',maxWidth:'90%',boxShadow:'0 4px 14px rgba(0,0,0,0.3)',fontFamily:'sans-serif'}}>
            <h3 style={{marginTop:0,fontSize:'18px'}}>Selecciona variante</h3>
            <p style={{fontSize:'12px',marginTop:0,color:'#555'}}>El código <strong>{variantModal.scannedCode}</strong> coincide con varias tallas/precios. Elige una:</p>
            <ul style={{listStyle:'none',padding:0,margin:'8px 0',maxHeight:'220px',overflowY:'auto'}}>
              {variantModal.options.map(p => (
                <li key={p.id} style={{marginBottom:'8px'}}>
                  <button onClick={()=>seleccionarVariante(p)} style={{width:'100%',textAlign:'left',background:'#1e88e5',color:'#fff',border:'none',padding:'10px 12px',borderRadius:'6px',cursor:'pointer',display:'flex',flexDirection:'column',gap:'3px'}}>
                    <span style={{fontWeight:'600',fontSize:'14px'}}>{p.concepto || p.nombre || 'Producto'} {p.talla ? `(${p.talla})` : ''}</span>
                    <span style={{fontSize:'12px',opacity:0.9}}>Precio: {Number(p.precio).toFixed(2)} | Stock: {p.cantidad ?? p.stock ?? 0}</span>
                  </button>
                </li>
              ))}
            </ul>
            <div style={{display:'flex',justifyContent:'flex-end',gap:'10px',marginTop:'6px'}}>
              <button onClick={cerrarVariante} style={{background:'#ccc',border:'none',padding:'8px 14px',borderRadius:'4px',cursor:'pointer'}}>Cancelar</button>
            </div>
          </div>
        </div>
      )}
      <p style={{fontSize:'0.7rem',opacity:0.7,marginTop:'8px'}}>Puedes escanear directamente aquí: el input oculto mantiene el foco.</p>
    </div>
  );
}
